import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUa = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 9 6",
	style: {
		width: ".75em",
		height: ".5em"
	},
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		id: "blue_stripe",
		width: 9,
		height: 3,
		y: 0,
		x: 0,
		fill: "#0057b7"
	}), /* @__PURE__ */ _jsx("rect", {
		id: "yellow_stripe",
		width: 9,
		height: 3,
		y: 3,
		x: 0,
		fill: "#ffd700"
	})]
});
export default SvgUa;
